import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  ShotsImage: {
    borderRadius: "8px",
  },
  shotListTableCell: {
    padding: "1px",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "23.3%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  shotListTableCellTwo: {
    padding: "1px",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "15%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  shotListPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
